/* eslint-disable no-unused-vars */
import React from "react";

import { TWO_DIGIT_DECIMAL_OPTIONAL_PATTERN } from "@stadium/helpers/form/constants";
import { EventArgs } from "@stadium/ui/types/form-text-input";

export const allowPositiveIntegerValueOnlyValidator = (e: EventArgs): EventArgs => {
  const cleaned = String(e.value ?? "").replaceAll(/\D/g, "");
  return {
    ...e,
    value: cleaned,
  };
};

export const allowTwoDecimalPlaces = (e: EventArgs) => ({
  ...e,
  value: TWO_DIGIT_DECIMAL_OPTIONAL_PATTERN.exec(e.value)?.[0],
});

export const allowPhoneOnlyValidator = (e: EventArgs): EventArgs => ({
  ...e,
  value: e.value.replace(/[^+0-9-]/g, ""),
});

export const generateEventHandlers: (
  focusFunction: React.ComponentPropsWithoutRef<"input">["onFocus"],
  blurFunction: React.ComponentPropsWithoutRef<"input">["onBlur"],
) => {
  onFocus: React.ComponentPropsWithoutRef<"input">["onFocus"];
  onBlur: React.ComponentPropsWithoutRef<"input">["onBlur"];
} = (focusFunction, blurFunction) => {
  // done in order to not support changing numbers through scroll
  // https://stackoverflow.com/questions/9712295/disable-scrolling-on-input-type-number
  const disableWheel = (e: Event) => e.preventDefault();
  return {
    onFocus: (e) => {
      e.currentTarget.addEventListener("wheel", disableWheel, { passive: false });
      return focusFunction?.(e);
    },
    onBlur: (e) => {
      e.currentTarget.removeEventListener("wheel", disableWheel);
      return blurFunction?.(e);
    },
  };
};
